import { useState, useEffect } from "react";
import SmHeader from "../../components/ForPages/SmHeader";
import HomeHeader from "../../components/ForPages/HomeHeader";
import { Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { getForm } from "../../actions/forms";
import { useDispatch } from "react-redux";
import Design from "../../components/ForPages/Design";
import DesignPopup from "../../components/ForPages/DesignPopup";
import Footer from "../../components/ForPages/Footer";
import PaymentPopup from "../../components/PaymentPopup";
import "./Home.css";
import ClientCreateDesignForm from "../../components/userForms/ClientCreateDesignForm";
import "./Responsive.css";

import { useHistory } from "react-router-dom";
import axiosInstance from "../../utils/config";
import loadFonts from "../../utils/fontsLoader";
import { canvas_designs } from "../../utils/designsTypes";

const ClientHome = () => {
  document.body.style.backgroundColor = "#E5E4EF";
  const [showCreateDesignForm, setShowCreateDesignForm] = useState(false);
  const dispatch = useDispatch(),
    [monthDownloadNbr, setMonthDownloadNumber] = useState(0),
    [totalDownloadNumber, setTotalDownloadNumber] = useState(0),
    [PaymentPopupDisplay, setPaymentPopupDisplay] = useState("none"),
    [designTitle, setDesignTitle] = useState(""),
    [popupDisplay, setPopupDisplay] = useState("none"),
    changeDesignTitle = (v) => {
      setDesignTitle(v);
      setPopupDisplay("flex");
      document.body.style.overflow = "hidden";
    },
    [designs, setDesigns] = useState([]),
    [userRole, setUserRole] = useState("client"),
    history = useHistory();
  const [userToken, setUserToken] = useState(
    localStorage?.getItem("skiUserToken")
  );

  useEffect(() => {
    if (history.location.search.includes("?modal=createDesign")) {
      setShowCreateDesignForm(true);
    }
  }, []);

  useEffect(async () => {
    const autoLogUserIn = () => {
      const email = "testing@testing.com";
      const password = "0987654321";

      axiosInstance
        .post("/login", { Email: email, Password: password })
        .then((data) => {
          localStorage.setItem("skiUserToken", data.data.token.split(" ")[1]);
          setUserToken(data.data.token.split(" ")[1]);
        });
    };

    document.title = "Ski Design | Generate Your Next Social Media Post Design";
    if (userToken) {
      try {
        let decodedToken = jwt_decode(userToken);
        setUserRole(decodedToken.AccountType);
        if (decodedToken.AccountType !== "client") autoLogUserIn();
        else {
          await axiosInstance
            .get("/user/downloads", {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
              },
            })
            .then((res) => {
              setMonthDownloadNumber(res.data.monthlyDownloads);
              setTotalDownloadNumber(res.data.totalDownloads);
            })
            .catch((err) => console.error(err));
        }
      } catch (err) {
        autoLogUserIn();
      }
    } else {
      // localStorage.removeItem("skiUserToken");
      // setUserRole("");
      // history.push("/");
      autoLogUserIn();
    }
  }, [userToken, history]);

  useEffect(() => {
    axiosInstance
      .get("/user/downloaded/templates", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
        },
      })
      .then((res) => {
        let temp_data = [];
        res.data.data.slice(0, 20).map((t) => {
          let canva_design = canvas_designs.find((d) => d.value === t.Category);
          if (canva_design) {
            let new_t = {
              imgSrc: "/Images/groovinx.png",
              title: t.Name,
              type: t.Category,
              width: canva_design.width,
              height: canva_design.height,
              templateFile: t.templateFile,
              _id: t._id,
            };

            temp_data.push(new_t);
          }
        });
        setDesigns(temp_data);
      })
      .catch((err) => console.log(err));

    loadFonts();
  }, [userToken]);
  // const openInNewTab = url => {
  //   window.open(url, '_blank', 'noopener,noreferrer');
  // };
  return (
    <>
      {showCreateDesignForm && (
        <ClientCreateDesignForm downloadNum={totalDownloadNumber} />
      )}
      <div className="Home ClientHome">
        {userRole !== "client" && <Redirect to="/" />}
        <SmHeader />
        <HomeHeader
          tab="home"
          include=""
          showPaymentPopup={setPaymentPopupDisplay}
        />
        <div className="Middle-welcome">
          <h2>Welcome to Skye Studio</h2>
          {/* <p>Generate 3 Free Design per month</p> */}
          <button
            className="btn btn-primary shadow-sm text-white"
            type="button"
            onClick={() => setShowCreateDesignForm(true)}
            onMouseOver={() => setShowCreateDesignForm(false)}
          >
            Create A Design
          </button>
        </div>
        <div className="creative-design-info">
          <div className="stats-container flex-sm-wrap align-items-center justify-content-center download-info">
            <h1 className="p-3">Stats</h1>
            <div className="stats-container flex-sm-wrap align-items-center justify-content-center">
              <div>
                <div>
                  <h3>{monthDownloadNbr} Downloads</h3>
                  <p>This Month</p>
                </div>
                <img src="./Images/green_cube.png" alt="Green cube" />
              </div>
              <div>
                <div>
                  <h3>{totalDownloadNumber} Downloads</h3>
                  <p>In Total</p>
                </div>
                <img src="./Images/orange_cube.png" alt="Orange cube" />
              </div>
            </div>
          </div>
          <div className="creative-designs-list">
            <h1 className="p-3">Created Designs</h1>
            <div className="designs-cont">
              {designs.length > 0 &&
                designs.map((design, index) => (
                  <Design
                    key={index}
                    design={design}
                    changeDesignTitle={changeDesignTitle}
                  />
                ))}
            </div>
          </div>
        </div>
        <Footer />
        <DesignPopup
          title={designTitle}
          display={popupDisplay}
          jwt_decode={jwt_decode}
        />
        <PaymentPopup
          display={PaymentPopupDisplay}
          hidePopupDisplay={setPaymentPopupDisplay}
        />
      </div>
    </>
  );
};

export default ClientHome;
